document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.form-request__form');
  const phoneInputs = document.querySelectorAll('input[type="tel"]');
  const itiInstances = new Map();

  phoneInputs.forEach((input) => {
    if (typeof window.intlTelInput !== 'function') {
      return;
    }

    const iti = window.intlTelInput(input, {
      initialCountry: 'ru',
      onlyCountries: ['ru', 'kz', 'by'],
      separateDialCode: true,
      customPlaceholder: (placeholder, countryData) => (
        countryData.iso2 === 'ru' ? '(999) 999-99-99' : placeholder
      )
    });

    itiInstances.set(input, iti);
  });

  const formatError = (error, evidenceRecorded) => (
    error?.userMessage
    || (
      evidenceRecorded
        ? 'Подтверждения зафиксированы, но заявку отправить не удалось. Повторите попытку позже.'
        : 'Не удалось зафиксировать обязательные подтверждения. Заявка не отправлена. Повторите попытку позже.'
    )
  );

  forms.forEach((form) => {
    const status = form.querySelector('[data-form-status]');
    const submitButton = form.querySelector('button[type="submit"]');
    const legalConsent = form.elements.legalConsent;
    const originalSubmitText = submitButton?.textContent || '';

    form.noValidate = true;

    const setStatus = (message = '', state = 'info') => {
      if (!status) {
        return;
      }

      status.textContent = message;
      status.hidden = !message;
      status.dataset.state = state;
      status.setAttribute('role', state === 'error' ? 'alert' : 'status');
    };

    const setBusy = (isBusy) => {
      form.setAttribute('aria-busy', String(isBusy));
      if (submitButton) {
        submitButton.disabled = isBusy;
        submitButton.setAttribute('aria-disabled', String(isBusy));
        submitButton.textContent = isBusy ? 'Отправляем…' : originalSubmitText;
      }
    };

    legalConsent?.addEventListener('change', () => setStatus());

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const phoneInput = form.querySelector('input[type="tel"]');
      const iti = itiInstances.get(phoneInput);
      const schoolInput = form.querySelector('input[name="school"]');
      const questionInput = form.querySelector('input[name="question"]');
      const commentInput = form.querySelector('input[name="comment"]');
      const name = form.elements.userName.value.trim();
      const phone = iti ? iti.getNumber() : phoneInput.value.trim();
      const mail = form.elements.email.value.trim();
      const school = schoolInput ? schoolInput.value.trim() : '';
      const question = questionInput ? questionInput.value.trim() : '';
      const comment = commentInput ? commentInput.value.trim() : '';
      const policyAcknowledged = Boolean(legalConsent?.checked);
      const processingConsentGranted = Boolean(legalConsent?.checked);
      const errors = [];

      if (!name) errors.push('Введите ФИО');
      if (!school && schoolInput) errors.push('Введите школу, представителем которой Вы являетесь');
      if (!question && questionInput) errors.push('Введите вопрос');
      if (iti && !iti.isValidNumber() && phoneInput.value !== '') {
        errors.push('Введите корректный номер телефона');
      }
      if (!mail.includes('@')) errors.push('Введите корректный Email');
      if (!policyAcknowledged || !processingConsentGranted) {
        errors.push(
          'Подтвердите ознакомление с политикой и согласие на обработку персональных данных'
        );
      }

      if (errors.length > 0) {
        setStatus(errors.join('. '), 'error');
        return;
      }

      if (!window.KF21ConsentManager?.ensureLegalEvidence) {
        setStatus(
          'Сервис фиксации подтверждений пока недоступен. Заявка не отправлена.',
          'error'
        );
        return;
      }

      setBusy(true);
      setStatus('Фиксируем подтверждения перед отправкой заявки…');
      let evidenceRecorded = false;

      try {
        await window.KF21ConsentManager.ensureLegalEvidence({
          policyAcknowledged,
          processingConsentGranted
        });
        evidenceRecorded = true;
        setStatus('Подтверждения зафиксированы. Отправляем заявку…');

        const data = {
          name,
          phone,
          mail,
          type: Number(form.getAttribute('formTypeId'))
        };

        if (schoolInput) data.school = school;
        if (questionInput) data.question = question;
        if (commentInput) data.comment = comment;

        const response = await fetch(
          window.KF21ConsentManager.resolveApiUrl(
            '/api/v1/identity/send-mail-of-lending'
          ),
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json; charset=UTF-8'
            }
          }
        );

        if (!response.ok) {
          throw new Error(`Landing form request failed with status ${response.status}`);
        }

        setStatus(
          data.type === 3
            ? 'Ваша заявка успешно отправлена!'
            : 'Ваш вопрос успешно отправлен! Наши сотрудники свяжутся с вами в ближайшее время.',
          'success'
        );
        form.reset();
        iti?.setCountry('ru');
      } catch (error) {
        setStatus(formatError(error, evidenceRecorded), 'error');
      } finally {
        setBusy(false);
      }
    });

    form.dataset.formEnhancement = 'ready';
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.setAttribute('aria-disabled', 'false');
    }
  });
});
